import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-boldest m-0" }
const _hoisted_5 = { class: "svg-icon svg-icon-3 mx-0 svg-icon-primary" }
const _hoisted_6 = { class: "card-body p-9 pb-0" }
const _hoisted_7 = { class: "svg-icon svg-icon-3" }
const _hoisted_8 = { class: "card mb-5 mb-xl-10" }
const _hoisted_9 = { class: "card-header" }
const _hoisted_10 = { class: "card-title m-0" }
const _hoisted_11 = { class: "fw-boldest m-0" }
const _hoisted_12 = { class: "svg-icon svg-icon-3 mx-0 svg-icon-primary" }
const _hoisted_13 = { class: "card-body p-9 pb-0" }
const _hoisted_14 = { class: "svg-icon svg-icon-3" }
const _hoisted_15 = { class: "card mb-5 mb-xl-10" }
const _hoisted_16 = { class: "card-header" }
const _hoisted_17 = { class: "card-title m-0" }
const _hoisted_18 = { class: "fw-boldest m-0" }
const _hoisted_19 = { class: "svg-icon svg-icon-3 mx-0 svg-icon-primary" }
const _hoisted_20 = { class: "card-body p-9 pb-0" }
const _hoisted_21 = { class: "svg-icon svg-icon-3" }
const _hoisted_22 = { class: "card mb-5 mb-xl-10" }
const _hoisted_23 = { class: "card-header" }
const _hoisted_24 = { class: "card-title m-0" }
const _hoisted_25 = { class: "fw-boldest m-0" }
const _hoisted_26 = { class: "card-body p-9 pb-0" }
const _hoisted_27 = { class: "svg-icon svg-icon-3" }
const _hoisted_28 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1.33rem","padding":"0"},
    class: "fas fa-reply"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ELDatatable = _resolveComponent("ELDatatable")!
  const _component_AddInteractiveActivitiesModal = _resolveComponent("AddInteractiveActivitiesModal")!
  const _component_AddCallOutRecordsModal = _resolveComponent("AddCallOutRecordsModal")!
  const _component_AddQuickInquiryModal = _resolveComponent("AddQuickInquiryModal")!
  const _directive_auth = _resolveDirective("auth")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.t("influencerAccount.salesInteractions")), 1),
          _withDirectives((_openBlock(), _createElementBlock("button", {
            type: "button",
            class: "btn btn-sm ms-3 btn-link p-2 border border-white d-flex",
            "aria-disabled": "true",
            "data-bs-toggle": "modal",
            title: "Add",
            "data-bs-target": "#modal_add_interactive_activities",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleAddConnection && _ctx.handleAddConnection(...args)))
          }, [
            _createElementVNode("span", _hoisted_5, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
            ])
          ])), [
            [_directive_auth, { auth: ['update'] }]
          ])
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
        _createVNode(_component_ELDatatable, {
          loading: _ctx.options.salesInteractionLoading,
          "table-columns": _ctx.options.salesInteractionColumns,
          "table-data": _ctx.options.salesInteractionList,
          "current-page": _ctx.options.salesInteractionCurrentPage,
          total: _ctx.options.salesInteractionTotal,
          "rows-per-page": _ctx.options.salesInteractionPageSize,
          onCurrentChange: _ctx.handleSalesInteractionCurrentChange,
          onItemsPerPageChange: _ctx.setSalesInteractionPerPage
        }, {
          start: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDate(row.start)), 1)
          ]),
          close_date: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDate(row.close_date)), 1)
          ]),
          actions: _withCtx(({ row }) => [
            _createVNode(_component_router_link, {
              to: 
              '/interactive-marketing/interactive-activities/' +
              row.id +
              '/information'
            ,
              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_7, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                ])
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }, 8, ["loading", "table-columns", "table-data", "current-page", "total", "rows-per-page", "onCurrentChange", "onItemsPerPageChange"])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h3", _hoisted_11, _toDisplayString(_ctx.t("influencerAccount.callOut")), 1),
          _withDirectives((_openBlock(), _createElementBlock("button", {
            type: "button",
            class: "btn btn-sm ms-3 btn-link p-2 border border-white d-flex",
            "aria-disabled": "true",
            "data-bs-toggle": "modal",
            title: "Add",
            "data-bs-target": "#modal_add_call_out_records",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleAddConnection && _ctx.handleAddConnection(...args)))
          }, [
            _createElementVNode("span", _hoisted_12, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
            ])
          ])), [
            [_directive_auth, { auth: ['update'] }]
          ])
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_13, [
        _createVNode(_component_ELDatatable, {
          loading: _ctx.options.callOutLoading,
          "table-columns": _ctx.options.callOutColumns,
          "table-data": _ctx.options.callOutList,
          "current-page": _ctx.options.callOutCurrentPage,
          total: _ctx.options.callOutTotal,
          "rows-per-page": _ctx.options.callOutPageSize,
          onCurrentChange: _ctx.handleCallOutCurrentChange,
          onItemsPerPageChange: _ctx.setCallOutPerPage
        }, {
          due_date: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDateTime(row.due_date)), 1)
          ]),
          action_date: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDateTime(row.action_date)), 1)
          ]),
          importance: _withCtx(({ row }) => [
            _createElementVNode("span", {
              class: _normalizeClass(["badge", _ctx.getStatusLabel(row.importance).statusClass])
            }, _toDisplayString(row.__show.importance), 3)
          ]),
          actions: _withCtx(({ row }) => [
            _createVNode(_component_router_link, {
              to: '/task-management/call-out-records/' + row.id + '/information',
              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_14, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                ])
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }, 8, ["loading", "table-columns", "table-data", "current-page", "total", "rows-per-page", "onCurrentChange", "onItemsPerPageChange"])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("h3", _hoisted_18, _toDisplayString(_ctx.t("influencerAccount.quickInquiry")), 1),
          _withDirectives((_openBlock(), _createElementBlock("button", {
            type: "button",
            class: "btn btn-sm ms-3 btn-link p-2 border border-white d-flex",
            "aria-disabled": "true",
            "data-bs-toggle": "modal",
            title: "Add",
            "data-bs-target": "#modal_add_quick_inquiry",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleAddConnection && _ctx.handleAddConnection(...args)))
          }, [
            _createElementVNode("span", _hoisted_19, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr075.svg" })
            ])
          ])), [
            [_directive_auth, { auth: ['update'] }]
          ])
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_20, [
        _createVNode(_component_ELDatatable, {
          loading: _ctx.options.quickInquiryLoading,
          "table-columns": _ctx.options.quickInquiryColumns,
          "table-data": _ctx.options.quickInquiryList,
          "current-page": _ctx.options.quickInquiryCurrentPage,
          total: _ctx.options.quickInquiryTotal,
          "rows-per-page": _ctx.options.quickInquiryPageSize,
          onCurrentChange: _ctx.handleQuickInquiryCurrentChange,
          onItemsPerPageChange: _ctx.setQuickInquiryPerPage
        }, {
          request_date: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDateTime(row.request_date)), 1)
          ]),
          quote_amount: _withCtx(({ row }) => [
            _createTextVNode(" € " + _toDisplayString(row.quote_amount), 1)
          ]),
          actions: _withCtx(({ row }) => [
            _createVNode(_component_router_link, {
              to: '/task-management/quick-inquiry/' + row.id + '/information',
              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_21, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                ])
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }, 8, ["loading", "table-columns", "table-data", "current-page", "total", "rows-per-page", "onCurrentChange", "onItemsPerPageChange"])
      ])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("h3", _hoisted_25, _toDisplayString(_ctx.t("influencerAccount.campaign")), 1)
        ])
      ]),
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_26, [
        _createVNode(_component_ELDatatable, {
          loading: _ctx.options.campaignLoading,
          "table-columns": _ctx.options.campaignColumns,
          "table-data": _ctx.options.campaignList,
          "current-page": _ctx.options.campaignCurrentPage,
          total: _ctx.options.campaignTotal,
          "rows-per-page": _ctx.options.campaignPageSize,
          onCurrentChange: _ctx.handleCampaignCurrentChange,
          onItemsPerPageChange: _ctx.setCampaignPerPage
        }, {
          start_date: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDate(row.start_date)), 1)
          ]),
          end_date: _withCtx(({ row }) => [
            _createTextVNode(_toDisplayString(_ctx.formatDate(row.end_date)), 1)
          ]),
          status: _withCtx(({ row }) => [
            _createElementVNode("span", {
              class: _normalizeClass(["badge", _ctx.getStatusLabel(row.status).statusClass])
            }, _toDisplayString(_ctx.getStatusLabel(row.status).str), 3)
          ]),
          actions: _withCtx(({ row }) => [
            _createVNode(_component_router_link, {
              to: 
              '/interactive-marketing/marketing-campaigns/' +
              row.id +
              '/Information'
            ,
              class: "btn btn-icon btn-bg-light btn-active-color-primary btn-sm"
            }, {
              default: _withCtx(() => [
                _createElementVNode("span", _hoisted_27, [
                  _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/art/art005.svg" })
                ])
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _: 1
        }, 8, ["loading", "table-columns", "table-data", "current-page", "total", "rows-per-page", "onCurrentChange", "onItemsPerPageChange"])
      ])), [
        [_directive_loading, _ctx.loading]
      ]),
      _createElementVNode("div", _hoisted_28, [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-secondary align-self-center me-2",
          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.backToList && _ctx.backToList(...args)))
        }, [
          _hoisted_29,
          _createTextVNode(" " + _toDisplayString(_ctx.t("common.backToList")), 1)
        ])
      ])
    ]),
    _createVNode(_component_AddInteractiveActivitiesModal, {
      accountId: _ctx.accountId,
      targetType: "1",
      onUpdateList: _ctx.getUpdateSalesInteractionList
    }, null, 8, ["accountId", "onUpdateList"]),
    _createVNode(_component_AddCallOutRecordsModal, {
      accountId: _ctx.accountId,
      taskSource: _ctx.taskSource,
      onUpdateList: _ctx.getUpdateCallOutList
    }, null, 8, ["accountId", "taskSource", "onUpdateList"]),
    _createVNode(_component_AddQuickInquiryModal, {
      accountId: _ctx.accountId,
      taskSource: _ctx.taskSource,
      onUpdateList: _ctx.getUpdateQuickInquiryList
    }, null, 8, ["accountId", "taskSource", "onUpdateList"])
  ], 64))
}